import { useRouter } from 'next/router'
import { translate } from '#src/common/components/translation'

export const useGetTranslation = () => {
  const { locale } = useRouter()
  const getTranslation = (id: string) => translate(id, locale)?.value
  return getTranslation
}
